import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next/src/index';
import { GetAttachmentData, Download } from '@hobs/utils/download';
import Toast from '@hobs/components/Toast';
import Icon from '../Icon';
import Styles from './File.module.scss';

const File = ({
  onRemove,
  name,
  url,
  onClick,
  attachmentId,
  disabled = false
}) => (
  <div className={Styles.file}>
    <a
      onClick={event => {
        if (attachmentId) {
          event.preventDefault();
          GetAttachmentData(attachmentId).then(results => {
            if (results.status === 400) {
              Toast.warning(results.payload.message);
            } else {
              Download(results, name);
            }
          });
        }

        if (onRemove) {
          event.preventDefault();
        }
        if (onClick) {
          event.preventDefault();
          onClick();
        }
      }}
      href={url}
      title={name}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon icon="attachment" />
      {name}
    </a>
    {onRemove && !disabled && (
      <button className={Styles.remove} type="button" onClick={onRemove}>
        <Icon icon="CloseSmall" />
      </button>
    )}
  </div>
);

File.propTypes = {
  onRemove: PropTypes.func,
  onClick: PropTypes.func,
  name: PropTypes.string,
  attachmentId: PropTypes.string,
  url: PropTypes.string,
  disabled: PropTypes.bool
};

export default withTranslation()(File);
